import request from '@/utils/request';

export function login(ticketId){
  return request({
    url: `/login/zlb-pc-zwykt?ticketId=${ticketId}`,
    method: 'get',
  })
}

// 获取厂房列表
export function getFactoryList(params) {
  return request({
    url: '/factory/app-page',
    method: 'get',
    params
  });
}

// 获取厂房详情
export function getFactoryDetail(id) {
  return request({
    url: `/factory/get/${id}/pc`,
    method: 'get'
  });
}


// 收藏厂房
export function collectFactory(factoryId) {
  return request({
    url: `/factory/collect/${factoryId}`,
    method: 'post'
  });
}

// 取消收藏
export function cancelCollect(collectionId) {
  return request({
    url: `/factory/cancelCollect/${collectionId}`,
    method: 'delete'
  });
}

// 获取我的收藏列表
export function getMyCollectList(params) {
  return request({
    url: '/factory/myCollect',
    method: 'get',
    params
  });
}

// 批量取消收藏
export function batchCancelCollect(ids) {
  return request({
    url: '/factory/batchCancelCollect',
    method: 'delete',
    data: ids
  });
} 

/**
 * 新增厂房信息
 * @param {Object} data 厂房信息
 * @returns result
 */
export function addFactoryInfo(data){
  return request({
    url: '/app/factoryInfo/add',
    method: 'post',
    data
  })
}

export const update = (data) => {
  return request({
      url: '/factory/update',
      method: 'put',
      data: data
  });
};

/**
 * 获取我的厂房信息列表
 * @param {Object} params 查询参数
 * @returns result
 */
export function getMyFactoryInfoList(params) {
  return request({
    url: '/factory/myFactoryInfoList',
    method: 'get',
    params
  });
}

/**
 * 上架
 * @param {*} id 
 * @returns 
 */
export const push = (id) => {
  return request({
      url: `/factory/push/${id}`,
      method: 'put'
  });
}

/**
 * 下架
 * @param {*} id 
 * @returns 
 */
export const line = (id) => {
  return request({
      url: `/factory/line/${id}`,
      method: 'put'
  });
}

export const del = (id) => {
  return request({
      url: `/factory/delete/${id}`,
      method: 'delete'
  });
};

// 获取求租房源列表
export function getDemandList(params) {
  return request({
    url: '/factory/app-page',
    method: 'get',
    params
  });
}

// 获取求租房源详情
export function getDemandDetail(id) {
  return request({
    url: `/factory/get/${id}`,
    method: 'get'
  });
}

//最近浏览
export function getRecentView() {
  return request({
    url: '/factory/myFactoryInfoList/recently',
    method: 'get'
  });
}